import React, { useState } from 'react';
import { collection, getDocs, query, where, limit } from 'firebase/firestore';
import { db } from '../firebaseConfig';

const AnalizarGruposPropiedades: React.FC = () => {
  const [ejecutando, setEjecutando] = useState(false);
  const [logs, setLogs] = useState<string[]>([]);

  const addLog = (message: string) => {
    setLogs(prev => [...prev, `[${new Date().toLocaleTimeString()}] ${message}`]);
    console.log(message);
  };

  const analizarGrupos = async () => {
    setEjecutando(true);
    setLogs([]);
    addLog('🔍 Analizando grupos de propiedades...');

    try {
      const propiedadesRef = collection(db, 'propiedades');
      const snapshot = await getDocs(propiedadesRef);

      addLog(`📊 Total propiedades: ${snapshot.size}`);
      addLog('');

      // Analizar fechas de creación
      const fechasCreacion = new Map<string, number>();
      const fechasModificacion = new Map<string, number>();

      snapshot.docs.forEach(doc => {
        const data = doc.data();

        // Analizar fecha de creación
        if (data.fecha_creacion) {
          const fecha = new Date(data.fecha_creacion.toDate()).toLocaleDateString();
          fechasCreacion.set(fecha, (fechasCreacion.get(fecha) || 0) + 1);
        }

        // Analizar fecha de modificación
        if (data.fecha_modificacion) {
          const fecha = new Date(data.fecha_modificacion.toDate()).toLocaleDateString();
          fechasModificacion.set(fecha, (fechasModificacion.get(fecha) || 0) + 1);
        }
      });

      addLog('📅 PROPIEDADES POR FECHA DE CREACIÓN:');
      Array.from(fechasCreacion.entries())
        .sort((a, b) => b[1] - a[1])
        .forEach(([fecha, count]) => {
          addLog(`  ${fecha}: ${count} propiedades`);
        });

      addLog('');
      addLog('📅 PROPIEDADES POR FECHA DE MODIFICACIÓN:');
      Array.from(fechasModificacion.entries())
        .sort((a, b) => b[1] - a[1])
        .forEach(([fecha, count]) => {
          addLog(`  ${fecha}: ${count} propiedades`);
        });

      addLog('');
      addLog('🔍 ANÁLISIS DE ESTRUCTURA POR GRUPO:');
      addLog('');

      // Analizar las que tenían "Sin título" (grupo corregido)
      addLog('📋 GRUPO 1: Propiedades que fueron corregidas (~2,629)');
      const muestraCorregidas = snapshot.docs
        .filter(doc => {
          const data = doc.data();
          const titulo = data.titulo || '';
          // Buscar las que fueron corregidas (ahora tienen "Propiedad XXX")
          return titulo.startsWith('Propiedad ') && titulo.includes(' en ');
        })
        .slice(0, 5);

      muestraCorregidas.forEach((doc, idx) => {
        const data = doc.data();
        addLog(`  --- Ejemplo ${idx + 1} ---`);
        addLog(`    ID: ${doc.id}`);
        addLog(`    Título: ${data.titulo}`);
        addLog(`    List Number: ${data.list_number || 'N/A'}`);
        addLog(`    Área: ${data.direccion?.area || 'N/A'}`);
        addLog(`    Tipo: ${data.tipo_propiedad || 'N/A'}`);
        if (data.fecha_creacion) {
          addLog(`    Fecha creación: ${new Date(data.fecha_creacion.toDate()).toLocaleString()}`);
        }
        addLog('');
      });

      addLog('');
      addLog('📋 GRUPO 2: Propiedades sin cambios (~3,433)');
      const muestraSinCambios = snapshot.docs
        .filter(doc => {
          const data = doc.data();
          const titulo = data.titulo || '';
          // Buscar las que no necesitaron corrección
          return !titulo.startsWith('Propiedad ') || !titulo.includes(' en ');
        })
        .slice(0, 5);

      muestraSinCambios.forEach((doc, idx) => {
        const data = doc.data();
        addLog(`  --- Ejemplo ${idx + 1} ---`);
        addLog(`    ID: ${doc.id}`);
        addLog(`    Título: ${data.titulo}`);
        addLog(`    List Number: ${data.list_number || 'N/A'}`);
        addLog(`    Área: ${data.direccion?.area || 'N/A'}`);
        addLog(`    Tipo: ${data.tipo_propiedad || 'N/A'}`);
        if (data.fecha_creacion) {
          addLog(`    Fecha creación: ${new Date(data.fecha_creacion.toDate()).toLocaleString()}`);
        }
        addLog('');
      });

      addLog('✅ Análisis completado');

    } catch (error: any) {
      addLog(`❌ Error: ${error.message}`);
    } finally {
      setEjecutando(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: '0 auto' }}>
      <h1>🔍 Análisis de Grupos de Propiedades</h1>

      <p>Este componente te ayudará a entender por qué tienes 6,062 propiedades cuando esperabas ~3,432.</p>

      <div style={{ marginBottom: '20px' }}>
        <button
          onClick={analizarGrupos}
          disabled={ejecutando}
          style={{
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: ejecutando ? '#ccc' : '#17a2b8',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: ejecutando ? 'not-allowed' : 'pointer'
          }}
        >
          {ejecutando ? '⏳ Analizando...' : '🔍 Analizar Grupos'}
        </button>
      </div>

      <div style={{
        backgroundColor: '#f5f5f5',
        padding: '15px',
        borderRadius: '4px',
        maxHeight: '600px',
        overflow: 'auto'
      }}>
        <h3>📋 Log de Análisis</h3>
        <div style={{
          fontFamily: 'monospace',
          fontSize: '12px',
          whiteSpace: 'pre-wrap'
        }}>
          {logs.map((log, index) => (
            <div key={index}>{log}</div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AnalizarGruposPropiedades;
